import { API_BASE_URL } from "../../../helpers/apiBaseUrl";

const token = () => {
  const value = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!value) return "";
  try { return JSON.parse(value); } catch { return value; }
};

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token()}`, ...options.headers },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) throw new Error(payload.message || payload.error || "Request failed.");
  return payload;
};

export const listUsers = (filters = {}) => request(`/admins?${new URLSearchParams({ size: 200, ...filters })}`);
export const listDepartments = () => request("/departments?status=1");
export const listDesignations = () => request("/lookups/designations?status=1");
export const createUser = (data) => request("/admins", { method: "POST", body: JSON.stringify(data) });
export const updateUser = (id, data) => request(`/admins/${id}`, { method: "PUT", body: JSON.stringify(data) });
export const deleteUser = (id) => request(`/admins/${id}`, { method: "DELETE" });
export const exportUsers = (filters = {}) => request("/admins/export", { method: "POST", body: JSON.stringify(filters) });
